export default __webpack_public_path__ + "static/media/logo_dark.aabbb00d.svg";